<template>
  <mds-combo-box :label="label" :data-set="dataset" :selectedItems="selectedItems" :error="error"
    :error-text="errorText" @input="Onchange">
  </mds-combo-box>
</template>
<script>
import MdsComboBox from "@mds/combo-box";
export default {
  inheritAttrs: false,
  model: {
    prop: "value",
    event: "change",
  },
  props: {
    dataset: {
      type: Array,
    },
    errorText: {
      type: Array,
    },
    error: {
      type: Boolean,
    },
    label: {
      type: String,
    },
    value: {
      type: Number,
    },
  },
  components: {
    MdsComboBox,
  },

  data() {
    return {
      isFocus: false,
    };
  },

  computed: {
    selectedItems() {
      let userInput = [];
      if (this.value > 0) {
        userInput.push(this.value.toString());

      }
      return userInput; 

  },
},
  async created() { },

  methods: {
    Onchange(newValue) {
      if (newValue.length > 0) {
        this.selectedItems = newValue;
        var selectedvalue = newValue[0];
        this.$emit("change", Number(selectedvalue));
      }
    },
  },
};
</script>
<style>
.mds-combo-box_CashFlow .mds-combo-box__single-select_CashFlow .mds-combo-box__single-input_CashFlow {
  left: 0 !important;
}
</style>
